import React from "react";
import { useExchangeRateOptional } from "../../../contexts/exchangeRate";

function formatNumber(value, precision = 2) {
  return new Intl.NumberFormat("tr-TR", {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  }).format(Number(value) || 0);
}

/**
 * Shared price display. Values are always USD; TL is a read-only view
 * shown when the header toggle sets the system currency to TRY.
 * If a custom `rate` is passed (e.g. sale's own exchange rate), that rate is used.
 * If no custom `rate` exists and `showFallbackMark` is true, a '*' mark is rendered
 * indicating the TRY amount was calculated from the live/current exchange rate.
 */
export default function ProductPrice({
  value,
  rate: customRate,
  showFallbackMark = false,
  fallbackMarkTitle = "Güncel kur ile hesaplandı (Satışa ait kur kaydı bulunamadı)",
  forceCurrency,
  className,
  showSuffix = true,
  precision = 2,
}) {
  const fx = useExchangeRateOptional();
  const amount = Number(value) || 0;
  const currency = forceCurrency || fx?.displayCurrency || "USD";

  const parsedCustom =
    customRate !== undefined && customRate !== null && customRate !== ""
      ? Number(String(customRate).replace(",", "."))
      : NaN;
  const hasCustomRate = !isNaN(parsedCustom) && parsedCustom > 0;

  const effectiveRate = hasCustomRate ? parsedCustom : (fx?.rate ?? null);
  const isUsingFallback = !hasCustomRate && currency === "TRY" && Boolean(effectiveRate);

  if (currency === "TRY" && effectiveRate) {
    return (
      <span className={className}>
        {formatNumber(amount * effectiveRate, precision)}
        {showSuffix ? " TL" : ""}
        {showFallbackMark && isUsingFallback && (
          <span
            className="text-warning fw-bold ms-1"
            title={fallbackMarkTitle}
            style={{ cursor: "help", fontSize: "1.05em" }}
          >
            *
          </span>
        )}
      </span>
    );
  }

  return (
    <span className={className}>
      {showSuffix ? "$" : ""}
      {formatNumber(amount, precision)}
    </span>
  );
}
